import { StyleSheet } from 'aphrodite';
import { brandSecondary } from '../../styles/colors';
import { Layouts } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		...Layouts.verticalStack(20),
		maxWidth: 500,
	},
	header: {
		color: brandSecondary,
		fontSize: 18,
	},
	ctaButton: {
		width: '100%',
	},
});
